import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import StatusButtons from "../../reusableComp/statusButton.js";

import { useState } from "react";
import { GlobalState } from "context/GlobalContext";
import { getLatestApproval } from "utils/supplierApprovalHelpers";
import ComplianceCertificates from "../CommonComponents/ComplianceCertificates/CompalianceCertificates";
import {
	EditCompanyDetailsModalTypes,
	companyBasicDetailColumns,
	companyCommunicationAddressDetailColumns,
	companyRegistredAddressDetailColumns,
	complianceCertColumns,
	contactPersonColumns,
	fileTableColumns,
	financialDetailsColumns,
	industryTypeValues,
	labourTableColumns,
	msmeIndustryColumns,
	paymentModeOptions,
	paymentTermColumns,
} from "data/supplierPageData";
import DisplayInfo from "../CommonComponents/DisplayInfo/DisplayInfo";
import EditCompanyDetails from "./EditCompanyDetails/EditCompanyDetails";
import LabourDataTable from "./LabourDataTable/LabourDataTable";
import EditAddressDetails from "./EditAddressDetails/EditAddressDetails";
import DisplayAddressInfo from "../DisplayAddressInfo/DisplayAddressInfo";
import EditContactPersons from "../CommonComponents/EditContactPersons/EditContactPersons";
import EditFinancialDetails from "./EditFinancialDetails/EditFinancialDetails";
import DisplayTable from "../CommonComponents/DisplayTable/DisplayTable";
import AddFiles from "../CommonComponents/AddFiles/AddFiles";
import axios from "axios";
import { Dialog, DialogActions, DialogContent, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { grey } from "@mui/material/colors";
import VerifyFinancialDetailsModal from "./VerifyFinancialDetailsModal/VerifyFinancialDetailsModal.js";
import { getSupplierFileSignedUrl } from "./data.js";
import parseErrMsgFromError from "utils/errorFunctions/parseErrorMessageFromError.js";
import { parse } from "date-fns";
import { SupplierPageHeader, SupplierSection } from "../../shared/supplierUi";

const CompanyDetails = ({
	pageData,
	setPageData,
	isOnboarded,
	setIsOnboarded,
	foreignKey,
	disableEdit,
	hidePageHeader = false,
	handleReject,
	updateSupplierStore,
	handleUnapprove,
	handleEditSApprovalDb,
}) => {
	const { setSnackBar, snackBar, setSnackBarOpen, loginUser, setLoadingOpen } = GlobalState();
	const latestApproval = (type) => getLatestApproval(pageData?.supplierApproval, type);

	// const [pageData, setPageData] = useState({
	// 	supplier_name: "",
	// 	company_name: "Company 1",
	// 	supplier_nature: "select",
	// 	company_type: "select",
	// 	no_of_factory: 0,
	// 	gst_no: "",
	// 	name_of_owner: "",
	// 	gender: "select",
	// 	position: "",
	// 	office_address: "",
	// 	office_state: "select",
	// 	office_city: "",
	// 	office_pin_code: "",
	// 	monthly_capacity: 0,
	// 	capacity_for_thor: 0,
	// 	no_of_labour: 0,
	// 	labour_roll: "select",
	// 	company_establishment_date: new Date(),

	// 	compliance_certificate_issuer: "",
	// 	compliance_certificate_issue_date: new Date(),
	// 	compliance_certificate_exp_date: new Date(),
	// 	website_link: "",
	// 	email: "",
	// 	mobile_no_primary: "",
	// 	mobile_no_secondary: "",
	// 	pan_no: "",
	// 	bank_name: "",
	// 	bank_ifsc_code: "",
	// 	bank_acc_no: "",
	// 	micr_code: "",
	// 	rtgs_code: "",
	// 	is_verified: false,
	// 	industry_type: "select",
	// });

	// const [pageData, setPageData] = useState(companyBasicDetailDummyValues);
	const [basicDetailsModal, setBasicDetailsModal] = useState(!isOnboarded);
	const [basicDetailsModalType, setBasicDetailsModalType] = useState(EditCompanyDetailsModalTypes.edit);

	const [addressDetailsModal, setAddressDetailsModal] = useState(false);
	const [financeDetailsModal, setFinanceDetailsModal] = useState(false);
	const [editContactModal, setEditContactModal] = useState(false);
	const [financeApproveModal, setFinanceApproveModal] = useState(false);
	const [selectedType, setSelectedType] = useState("");

	const [files, setFiles] = useState(
		pageData?.supplierFiles
			? pageData.supplierFiles
			: [
					// { name: "comp_cert", url: "https://google.com", type: "Compliance_Certificate" },
					// { name: "pan_card_photo", url: "https://google.com", type: "Pan_Card_Photo" },
					// { name: "blank_check_photo", url: "https://google.com", type: "Blank_Check_photocopy" },
					// { name: "office_gst_certificate", url: "https://google.com", type: "Office_gst_certificate" },
			  ]
	);
	const [contactPersons, setContactPersons] = useState(pageData.supplierContactPersons ? pageData.supplierContactPersons : []);
	const [complianceCerts, setComplianceCerts] = useState(
		pageData.supplierComplianceCertificates ? pageData.supplierComplianceCertificates : []
	);

	const date = new Date();

	const updateCompanyDetails = async (body, setModalOpen) => {
		setLoadingOpen(true);
		try {
			await axios.put(`/api/supplier/update/${pageData.id}`, body).then(async (res) => {
				// setPageData({ ...pageData, ...body });
				if (!isOnboarded) {
					setIsOnboarded(true);
					const uploaded = await handleFileAdd(body.files, true);
					if (uploaded) {
						window.location.reload();
					} else throw new Error("Error in file Upload");
					setLoadingOpen(false);
				} else {
					handleEditSApprovalDb(selectedType, { ...pageData, ...body });
					setModalOpen(false);
					setLoadingOpen(false);
					setSnackBarOpen(true);
					setSnackBar({
						...snackBar,
						message: "Saved",
						severity: "success",
						anchorOrigin: { horizontal: "center", vertical: "top" },
					});
				}
			});
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: parseErrMsgFromError(error),
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
		}
	};
	const updateFilename = (fileData, nameCol = "", col2) => {
		const Newname = `${nameCol ? fileData[nameCol]?.split(" ").join("_") : ""}_${
			col2 ? fileData[col2] : ""
		}_${new Date().valueOf()}`;
		return new File([fileData.file], Newname, {
			type: fileData.file.type,
			lastModified: fileData.file.lastModified,
		});
	};
	const handleFileUploadGCP = async (fileData, isMultiple, nameCol = "", col2 = "") => {
		// type is factory/company
		console.log(fileData, nameCol, "dsmfbsdmfbsdf");
		const formData = new FormData();
		// for setting folderPath
		formData.append("id", pageData.id);
		if (isMultiple) {
			for (let i = 0; i < fileData.length; i++) {
				formData.append("files", updateFilename(fileData[i], nameCol, col2));
			}
			return await axios
				.post("/api/supplier/file_upload", formData, { headers: { "Content-Type": "multipart/form-data" } })
				.then((res) => {
					return res.data;
				})
				.catch((err) => {
					return "Error in file Upload";
				});
		} else {
			formData.append("file", updateFilename(fileData, nameCol, col2));
			return await axios
				.post("/api/supplier/single_file_upload", formData, {
					headers: { "Content-Type": "multipart/form-data" },
				})
				.then((res) => {
					return res.data;
				})
				.catch((err) => {
					return "Error in file Upload";
				});
		}
	};
	const uploadFileDataToSQL = async (fileData) => {
		const res = await axios.post("/api/supplier/file_data_to_sql", fileData);
		return res?.data?.result;
	};
	const uploadComplianceCertToSQL = async (fileData) => {
		const res = await axios.post("/api/supplier/compliance_cert_to_sql", fileData);
		return res?.data?.result;
	};

	const handleFileAdd = async (fileData, isMultiple) => {
		try {
			if (fileData) {
				const fileLinkData = await handleFileUploadGCP(
					fileData,
					isMultiple,
					fileTableColumns.name.key,
					fileTableColumns.type.key
				);
				let newFiles = [];
				if (isMultiple) {
					const updatedFiles = fileData.map((row, i) => {
						let obj = { ...row, url: fileLinkData[i] };
						obj[foreignKey] = pageData.id;
						delete obj["file"];
						return obj;
					});
					newFiles = updatedFiles;
				} else {
					const file = { ...fileData, url: fileLinkData };
					file[foreignKey] = pageData.id;
					delete file["file"];
					newFiles = [file];
				}
				const data = await uploadFileDataToSQL(newFiles);
				// console.log(data);
				if (data) {
					let arr = [];
					if (isMultiple) arr = [[...files, ...data]];
					else arr = [...files, data?.[0]];
					setFiles(arr);
					return true;
				}
			}
		} catch (error) {
			console.log(error);
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: parseErrMsgFromError(error),
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
		}
	};

	const [selectedContact, setSelectedContact] = useState();

	const addCertificateFunction = async (fileData) => {
		try {
			if (fileData) {
				const fileLinkData = await handleFileUploadGCP(
					fileData,
					false,
					complianceCertColumns.compliance_certificate_issuer.key
				);
				let newFiles = [];
				const file = { ...fileData, url: fileLinkData };
				file[foreignKey] = pageData.id;
				delete file["file"];
				newFiles = [file];

				const data = await uploadComplianceCertToSQL(newFiles);
				// console.log(data);
				if (data?.[0]) {
					let arr = [...complianceCerts, data?.[0]];
					setComplianceCerts(arr);
					return true;
				} else throw new Error("Error in file Upload");
			}
		} catch (error) {
			console.log(error);
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: parseErrMsgFromError(error),
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			return false;
		}
	};
	const addContactPerson = async (data) => {
		try {
			if (data) {
				data[foreignKey] = pageData.id;
				if (selectedContact) {
					const res = await axios.put("/api/supplier/update_contact", data);
					if (res) {
						let cp = contactPersons.map((row) => {
							if (data.id === row.id) return data;
							else return row;
						});
						setContactPersons(cp);
						setSnackBarOpen(true);
						handleEditSApprovalDb(selectedType, pageData);
						setSnackBar({
							...snackBar,
							message: "Updated",
							severity: "success",
							anchorOrigin: { horizontal: "center", vertical: "top" },
						});
						return true;
					}
				} else {
					const res = await axios.post("/api/supplier/create_contact", data);
					if (res) {
						setContactPersons([...contactPersons, res.data.result]);
						setSnackBarOpen(true);
						setSnackBar({
							...snackBar,
							message: "Created",
							severity: "success",
							anchorOrigin: { horizontal: "center", vertical: "top" },
						});
						return true;
					}
				}
			}
		} catch (error) {
			console.log(error);
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: "Unable To Add File",
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			return false;
		}
	};
	const handleContactClick = (contact) => {
		setSelectedContact(contact);
		setEditContactModal(true);
	};

	const handleFinanceApproveClick = () => {
		let emptyFiledsColumns = [];
		Object.values(financialDetailsColumns).map((col) => {
			if (
				pageData[col.key] === "" ||
				pageData[col.key] === null ||
				pageData[col.key] === undefined ||
				pageData[col.key]?.toLowerCase() === "na" ||
				pageData[col.key] === "N/A"
			) {
				emptyFiledsColumns.push(col);
			}
		});
		if (emptyFiledsColumns.length > 0) {
			let message = (
				<p>
					Cannot Approve the details... Following fields are not filled:
					<br />
					{emptyFiledsColumns.map((row) => row.name).join(", ")}
					<br />
					(NA Not Allowed)
				</p>
			);
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: message,
				severity: "warning",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			return;
		}
		if (pageData.transaction_no && pageData?.transaction_no.length > 0) {
			updateSupplierStore("financial_details");
		} else setFinanceApproveModal(true);
		console.log(pageData, pageData.transaction_no);
	};

	const handleVerifyPaymentModeClick = async (transaction_no) => {
		try {
			await axios.put(`/api/supplier/update/${pageData.id}`, { transaction_no }).then((res) => {
				setPageData({ ...pageData, transaction_no });
				setFinanceApproveModal(false);
				setSnackBarOpen(true);
				setSnackBar({
					...snackBar,
					message: "Payment Mode Verified ",
					severity: "success",
					anchorOrigin: { horizontal: "center", vertical: "top" },
				});
				updateSupplierStore("financial_details");
			});
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: parseErrMsgFromError(error),
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
		}
	};
	const handleRejectedButton = (type) => {
		if (typeof handleReject === "function") handleReject(type);
	};
	const logeduser = loginUser.role?.FINANCE_VIEWER ? true : false;

	const handleFileDeleteclick = async (row) => {
		if (!disableEdit) {
			setLoadingOpen(true);
			try {
				await axios.delete(`/api/supplier/delete_supplier_file/${row.id}`).then((res) => {
					setFiles(files.filter((cert) => row.id !== cert.id));
					setSnackBarOpen(true);
					setSnackBar({
						...snackBar,
						message: "Deleted",
						severity: "success",
						anchorOrigin: { horizontal: "center", vertical: "top" },
					});
					setLoadingOpen(false);
				});
			} catch (error) {
				setSnackBarOpen(true);
				setSnackBar({
					...snackBar,
					message: "Unable To Delete",
					severity: "error",
					anchorOrigin: { horizontal: "center", vertical: "top" },
				});
				setLoadingOpen(false);
			}
		}
	};

	return (
		<Stack width="100%" spacing={2.5}>
			{!hidePageHeader && (
				<SupplierPageHeader
					title={pageData?.company_name || "Supplier"}
					subtitle="Company profile, documents, and contact information"
				/>
			)}

			<SupplierSection
				title="Basic Details"
				actions={
					<StatusButtons
						handleReject={() => handleRejectedButton("basic_details")}
						handleApproval={() => updateSupplierStore("basic_details")}
						handleUnapprove={() => handleUnapprove && handleUnapprove("basic_details")}
						disableEdit={disableEdit}
						handleEdit={() => {
							setBasicDetailsModal(true);
							setSelectedType("basic_details");
						}}
						otherAccess={!logeduser}
						editButton={true}
						buttonName="Edit"
						approved={latestApproval("basic_details")?.approved}
						remark={latestApproval("basic_details")?.remark}
						action={latestApproval("basic_details")?.action}
					/>
				}>
				<DisplayInfo
					labelData={
						pageData && pageData[companyBasicDetailColumns.industry_type.key] === industryTypeValues.msme
							? { ...companyBasicDetailColumns, ...msmeIndustryColumns }
							: companyBasicDetailColumns
					}
					values={pageData}
				/>
				<Box mt={2.5}>
					<LabourDataTable data={pageData} setData={setPageData} editable={false} columns={labourTableColumns} />
				</Box>
			</SupplierSection>

			<SupplierSection title="Office Use">
				<DisplayInfo labelData={paymentTermColumns} values={pageData} />
			</SupplierSection>

			<SupplierSection
				title="Address Details"
				actions={
					<StatusButtons
						handleReject={() => handleRejectedButton("address_details")}
						handleApproval={() => updateSupplierStore("address_details")}
						handleUnapprove={() => handleUnapprove && handleUnapprove("address_details")}
						disableEdit={disableEdit}
						handleEdit={() => {
							setAddressDetailsModal(true);
							setSelectedType("address_details");
						}}
						otherAccess={!logeduser}
						editButton={true}
						buttonName="Edit"
						approved={latestApproval("address_details")?.approved}
						remark={latestApproval("address_details")?.remark}
						action={latestApproval("address_details")?.action}
					/>
				}>
				<Box
					display="grid"
					gridTemplateColumns={{ xs: "1fr", md: "1fr 1fr" }}
					columnGap={4}
					rowGap={3}>
					<DisplayAddressInfo labelData={companyRegistredAddressDetailColumns} values={pageData} />
					<DisplayAddressInfo labelData={companyCommunicationAddressDetailColumns} values={pageData} />
				</Box>
			</SupplierSection>

			<SupplierSection
				title="Financial Details"
				actions={
					<StatusButtons
						handleReject={() => handleRejectedButton("financial_details")}
						handleApproval={() => handleFinanceApproveClick()}
						handleUnapprove={() => handleUnapprove && handleUnapprove("financial_details")}
						disableEdit={disableEdit}
						editButton={true}
						handleEdit={() => {
							setFinanceDetailsModal(true);
							setSelectedType("financial_details");
						}}
						otherAccess={logeduser}
						buttonName="Edit"
						approved={latestApproval("financial_details")?.approved}
						remark={latestApproval("financial_details")?.remark}
						action={latestApproval("financial_details")?.action}
					/>
				}>
				<DisplayInfo labelData={financialDetailsColumns} values={pageData} />
			</SupplierSection>

			<SupplierSection
				title="Files"
				actions={
					<StatusButtons
						handleReject={() => handleRejectedButton("files")}
						handleApproval={() => updateSupplierStore("files")}
						handleUnapprove={() => handleUnapprove && handleUnapprove("files")}
						disableEdit={disableEdit}
						editButton={false}
						buttonName="Edit"
						handleEdit={() => {}}
						otherAccess={!logeduser}
						approved={latestApproval("files")?.approved}
						remark={latestApproval("files")?.remark}
						action={latestApproval("files")?.action}
					/>
				}>
				<Stack
					direction={{ xs: "column", md: "row" }}
					spacing={2.5}
					alignItems="stretch"
					justifyContent="space-between">
					<Box flexGrow={1} minWidth={0} sx={{ maxHeight: 420, overflowY: "auto", overflowX: "hidden" }}>
						<DisplayTable
							rows={files}
							columns={fileTableColumns}
							downloadUrlColumn="url"
							deleteFun={handleFileDeleteclick}
							disableEdit={disableEdit}
							generateFileDownloadUrl={getSupplierFileSignedUrl}
						/>
					</Box>
					{!disableEdit && (
						<Box width={{ xs: "100%", md: 320 }} flexShrink={0}>
							<AddFiles
								fullWidth
								files={files}
								setFiles={setFiles}
								submitFunction={handleFileAdd}
								disableAdd={disableEdit || latestApproval("files")?.approved}
							/>
						</Box>
					)}
				</Stack>
			</SupplierSection>

			<SupplierSection
				title="Compliance Certificates"
				actions={
					<StatusButtons
						handleReject={() => handleRejectedButton("compliance_certificates")}
						handleApproval={() => updateSupplierStore("compliance_certificates")}
						handleUnapprove={() => handleUnapprove && handleUnapprove("compliance_certificates")}
						disableEdit={disableEdit}
						editButton={false}
						buttonName="Edit"
						handleEdit={() => {}}
						otherAccess={!logeduser}
						approved={latestApproval("compliance_certificates")?.approved}
						remark={latestApproval("compliance_certificates")?.remark}
						action={latestApproval("compliance_certificates")?.action}
					/>
				}>
				<ComplianceCertificates
					complianceCerts={complianceCerts}
					disableEdit={disableEdit}
					setComplianceCerts={setComplianceCerts}
					addCertificateFunction={addCertificateFunction}
					disableAdd={disableEdit || latestApproval("compliance_certificates")?.approved}
				/>
			</SupplierSection>

			<SupplierSection
				title="Contact Details"
				actions={
					<StatusButtons
						handleReject={() => handleRejectedButton("contact_details")}
						handleApproval={() => updateSupplierStore("contact_details")}
						handleUnapprove={() => handleUnapprove && handleUnapprove("contact_details")}
						disableEdit={disableEdit}
						handleEdit={() => {
							setEditContactModal(true);
							setSelectedType("contact_details");
						}}
						editButton={true}
						otherAccess={!logeduser}
						buttonName="Add"
						approved={latestApproval("contact_details")?.approved}
						remark={latestApproval("contact_details")?.remark}
						action={latestApproval("contact_details")?.action}
					/>
				}>
				<DisplayTable
					columns={contactPersonColumns}
					rows={contactPersons}
					disableEdit={
						disableEdit || latestApproval("contact_details")?.approved ? true : false
					}
					onRowClick={
						disableEdit || latestApproval("contact_details")?.approved ? () => {} : handleContactClick
					}
				/>
			</SupplierSection>

			{/* Models */}
			<EditCompanyDetails
				modalOpen={basicDetailsModal}
				setModalOpen={setBasicDetailsModal}
				basicDetails={pageData}
				setBasicDetails={setPageData}
				type={basicDetailsModalType}
				isOnboarded={isOnboarded}
				submitFunction={updateCompanyDetails}
			/>
			<EditAddressDetails
				modalOpen={addressDetailsModal}
				setModalOpen={setAddressDetailsModal}
				addressData={pageData}
				setAddressData={setPageData}
				submitFunction={updateCompanyDetails}
			/>
			<EditFinancialDetails
				modalOpen={financeDetailsModal}
				setModalOpen={setFinanceDetailsModal}
				data={pageData}
				setData={setPageData}
				submitFunction={updateCompanyDetails}
			/>
			<EditContactPersons
				modalOpen={editContactModal}
				setModalOpen={setEditContactModal}
				selected={selectedContact}
				setSelected={setSelectedContact}
				submitFunction={addContactPerson}
				key={editContactModal}
			/>

			<VerifyFinancialDetailsModal
				pageData={pageData}
				submitFunction={handleVerifyPaymentModeClick}
				modalOpen={financeApproveModal}
				setModalOpen={setFinanceApproveModal}
			/>
		</Stack>
	);
};

export default CompanyDetails;
